.rightActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
}

.addNewBtnContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
}

.btn {
  border-radius: var(--ant-border-radius-xs);
}

.marginBottomMd {
  margin-bottom: var(--ant-padding-md);
}

.searchInput {
  width: 508px;
}

.width100 {
  width: 100%;
  justify-content: space-between;
}

.viewToggle {
  margin-left: var(--ant-margin-xs);

  .viewToggleBtn {
    padding: 0 var(--ant-padding-xs);
  }
}
